import { FlosIcon, SectionHeader, SelectableBoxField } from '@flos/react-ui';
import { useEffect } from 'react';
import { useResourceBundle } from '../contexts/ResourceContext';
import { useAppDispatch, useAppSelector } from '../hooks/useRedux';
import { determineSelectionFromPath } from '../services/area';
import { navigationActions } from '../store/navigation.slice';
import { AreaType } from '../store/navigation.type';
import Categories from './Categories';

const areaUi: {
  [key in AreaType]: { icon: string; label: string };
} = {
  private: {
    icon: 'person-family',
    label: 'label.area.private',
  },
  commercial: {
    icon: 'attache',
    label: 'label.area.commercial',
  },
  agriculture: {
    icon: 'tractor',
    label: 'label.area.agriculture',
  },
};

const Area = () => {
  const dispatch = useAppDispatch();
  const selectedArea = useAppSelector((state) => state.navigation.area);
  const resource = useResourceBundle();

  useEffect(() => {
    dispatch(navigationActions.selectArea(determineSelectionFromPath()));
  }, [dispatch]);

  const select = (val: string) => {
    dispatch(navigationActions.selectArea(val as AreaType));
  };

  return (
    <>
      <SectionHeader title={resource['label.area.header']} />
      <SelectableBoxField
        options={Object.entries(areaUi).map(([area, ui]) => ({
          label: (
            <>
              <FlosIcon shape={ui.icon} size="small" />
              {resource[ui.label]}
            </>
          ),
          value: area,
        }))}
        onChangeValue={select}
        value={selectedArea ?? ''}
      />
      <Categories />
    </>
  );
};

export default Area;
